
import Vue from 'vue';

import SubmitButton from '@/components/controls/submit-button.vue';
import Dropdown, { DropdownItems } from '@/components/controls/dropdown.vue';
import ProductSelectionControl from '@/components/controls/product-selection.vue';
import LanguagePicker from '@/components/controls/language-picker.vue';
import { BannerStandImageStatus } from '@/store/modules/banner-stand-images/banner-stand-image';

export default Vue.extend({
  name: 'BannerStandImagesFilter',
  components: {
    SubmitButton,
    Dropdown,
    ProductSelectionControl,
    LanguagePicker,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dropdownItems(): DropdownItems {
      return {
        reset: {
          label: this.$t('Reset Filters'),
          icon: 'close',
        },
      };
    },
  },
  data() {
    return {
      availableStatuses: {
        [BannerStandImageStatus.Active]: this.$t('Active'),
        [BannerStandImageStatus.Inactive]: this.$t('Inactive'),
      },
      search: '',
      status: '',
      language: '',
      product: undefined as number | undefined,
    };
  },
  methods: {
    initFilters(): void {
      this.search = this.$router.currentRoute.query.search as string || '';
      this.status = this.$router.currentRoute.query.status as string || '';
      this.language = this.$router.currentRoute.query.language_code as string || '';

      let newProductValue: number | undefined;

      if (this.$router.currentRoute.query.product_id) {
        newProductValue = Number(this.$router.currentRoute.query.product_id);

        if (!newProductValue || Number.isNaN(newProductValue)) {
          newProductValue = undefined;
        }
      }

      if (this.product !== newProductValue) {
        this.product = newProductValue;
      }
    },
    applyFilters(): void {
      const { sort, direction, ...queryParams } = this.$route.query;

      this.$router.push({
        params: {
          page: 1,
        },
        query: {
          ...queryParams,
          status: this.status || undefined,
          search: this.search || undefined,
          language_code: this.language || undefined,
          product_id: this.product ? String(this.product) : undefined,
        },
      });
    },
    handleDropdownClick(action: string): void {
      if ('reset' === action) {
        this.$router.push({
          params: {
            page: 1,
          },
          query: {},
        });
      }
    },
  },
  created(): void {
    this.initFilters();
  },
  watch: {
    $route(): void {
      this.initFilters();
    },
  },
});
